import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import tw, { css, styled } from 'twin.macro'
import useCart from '../../hooks/useCart'
import useTheme from '../../hooks/theme'
import { ChevronDown, ChevronUp, ChevronRight } from 'react-feather'
import AccordionComponent from './accordion'
import { Accordion } from '@reach/accordion'
import '@reach/accordion/styles.css'
import useProduct from '../../hooks/useProduct'
import useWindowResize from '../../hooks/useWindowResize'
import { onAddToCart } from '../utils/analytics'
import Magnifier from 'react-magnifier'
import Spinner from '../utils/spinner'
import { Link, navigate } from 'gatsby'
import { getZaBuyLink } from '../utils/zaProductLinks'
import { getPricingInfo } from '../utils/pricingConfig'
import UpsellDialog, { hasUpsell } from './upsell-dialog'

const windowGlobal = typeof window !== 'undefined' && window

import {
	ProductInfoContainer,
	ProductContainer,
	ProductImageContainer,
	ProductImage,
	ProductImageHolder,
	ProductImagesContainer,
	ProductImageList,
	InfoContainer,
	BreadCrumbsContainer,
	Crumbs,
	SeriesCrumbs,
	ProductTitle,
	Price,
	SKU,
	CtaContainer,
	Button,
	Request,
	BookQuote,
	CompareBtn,
	ControlsContainer,
	IncrementBtn,
	DecrementBtn,
	FssContainer,
	TabsContainer,
	Tab,
	TabDetailsContainer,
	SpecificationsContainer,
	SpecificationsList,
	SpecificationsListItem,
	SpecDetail,
	Spec,
	SpecGroupTitle,
	SupportContainer,
	Manual,
	MSDS,
	WarrantyDownload,
	SafetyInstructions,
	Brochure,
	Parts,
	SpecInnerItem,
	CircleSvg,
	ProductIframe,
	Stock,
} from './styles'

const ProductInfo = ({
	imageArray,
	brand,
	series,
	model,
	price,
	sku,
	categories,
	shippingClass,
	slug,
	val,
	feature,
	specifications,
	brochure,
	manual,
	msds,
	warrantyDownload,
	safetyInstructions,
	distinction,
	tags,
	brandPage,
	title,
	comparisonitem,
	seriesPageDetails,
	degreeView,
	zoom,
	active,
	instock,
	comingSoon,
	linkto,
	checkedLocale,
	currency,
	locale,
}) => {
	const comparison =
		comparisonitem === null ? true : comparisonitem ? true : false
	const isZaEnquireProduct =
		locale === 'en-ZA' &&
		(brand === 'EcoSwim' ||
			brand === 'Eco Swim' ||
			brand === 'Mineral Swim' ||
			series === 'Eco Swim' ||
			series === 'Mineral Swim' ||
			(brandPage && (brandPage.slug === 'ecoswim' || brandPage.slug === 'mineral-swim')) ||
			(slug && (slug.includes('ecoswim') || slug.includes('mineral-swim'))))
	const { addToCart } = useCart()
	const { openCart } = useTheme()
	const item = {
		img: imageArray[0] != undefined ? imageArray[0].fluid.src : '',
		slug: slug,
		name: title,
		sku: sku,
		price: Number(price * 100),
		quantity: val,
		brand,
		category: [categories && categories.title].toString(),
		shippingClass,
	}
	const [value, setValue] = useState(item)
	const { width } = useWindowResize()
	const images = [
		...imageArray,
		{
			roundview: degreeView,
		},
	]
	const [ActiveProductImage, ReplaceActiveImage] = useState(
		images[0] != undefined ? images[0] : null
	)
	const [imageMap, ReplaceMapped] = useState(images)
	const [features, setFeature] = useState(feature)
	const [activeDetail, setActiveDetail] = useState(0)
	const ItemDetails = [
		{
			name: 'Features',
			active: true,
		},
		{
			name: 'Specifications',
			active: false,
		},
		{
			name: 'Support',
			active: false,
		},
	]

	const [activeTab, setActiveTab] = useState(ItemDetails)

	const changeValueHandler = e => {
		setValue({ ...item, quantity: Number(e.target.value) })
	}

	const incrementHandler = () => {
		setValue(prev => ({ ...item, quantity: Number(prev.quantity) + 1 }))
	}

	const decrementHandler = () => {
		setValue(prev => ({ ...item, quantity: Number(prev.quantity) - 1 }))
	}

	const activeTabHandler = index => {
		let active = activeTab.map((x, i) => {
			return i === index ? { ...x, active: true } : { ...x, active: false }
		})
		setActiveTab(active)
		setActiveDetail(index)
	}

	useEffect(() => {
		const newState = features
			? features.map(feature => {
					return { ...feature, isOpen: false }
			  })
			: null
		setFeature(newState)
	}, [])

	const brochureFile = brochure && brochure[0] && brochure[0].file.url
	const safetyInstructionsFile = "https://assets.ctfassets.net/ftcnv5up9dxv/2uexP7QYnBmTjOjI26QSz/a18878a344b8bec00c72d14dce46c832/Safety_Instructions.pdf"
	const manualFile = manual && manual[0] && manual[0].file.url
	const msdsFile = msds && msds.file.url
	const warrantyFile = warrantyDownload && warrantyDownload.file.url
	const Cb = model ? model.split(' ').indexOf('CB') : ''

	const commercialCheck = tags.includes('commercial')
	const residentialCheck = tags.includes('residential')
	const tagCheck = commercialCheck
		? 'commercial'
		: residentialCheck
		? 'residential'
		: ''

	const { addToTable } = useProduct()
	const checkLength = (key, e, brandPage, tagCheck, title) => {
		const items = windowGlobal.sessionStorage.getItem(key)
		const parsedItems = JSON.parse(items)
		if (width > 1023) {
			if (parsedItems.length >= 3) {
				e.preventDefault()
				if (
					windowGlobal.confirm(`Items to compare cannot be more than 3.
Clicking OK will redirect you to the product comparison page.`)
				) {
					window.location.href = `${checkedLocale}/product-comparison#${key}`
				}
			} else {
				addToTable(brandPage, tagCheck, title)
			}
		} else {
			if (parsedItems.length >= 2) {
				e.preventDefault()
				if (
					windowGlobal.confirm(`Items to compare cannot be more than 2.
Clicking OK will redirect you to the product comparison page.`)
				) {
					window.location.href = `${checkedLocale}/product-comparison#${key}`
				}
			} else {
				addToTable(brandPage, tagCheck, title)
			}
		}
	}

	const [zoomImg, setZoomImg] = useState(
		zoom?.images != undefined ? zoom.images[0] : null
	)

	const [promoModel, setPromoModel] = useState(null)

	const getCountry = locale.split('-')[1].toLowerCase()
	const array = ['spare-parts', 'pool-equipment']

	const crumbLink =
		brand === 'Niya'
			? `${checkedLocale}/niya`
			: `${checkedLocale}/${brandPage ? brandPage.slug : '#'}`
	return (
		<ProductInfoContainer>
			<ProductContainer>
				<ProductImageHolder>
					<ProductImagesContainer>
						<ProductImageList>
							{imageMap.map((image, i) => {
								return image?.roundview === undefined ? (
									<li key={i}>
										<img
											src={image.fluid.src}
											onClick={() => {
												ReplaceActiveImage(imageMap[i])
												setZoomImg(zoom.images[i])
											}}
											onKeyDown={() => {
												ReplaceActiveImage(imageMap[i])
												setZoomImg(zoom.images[i])
											}}
											alt={image.description}
											loading={i === 0 ? 'eager' : 'lazy'}
										/>
									</li>
								) : image?.roundview != null ? (
									<li key={i} className="roundview">
										<p
											onClick={() => ReplaceActiveImage(imageMap[i])}
											onKeyDown={() => ReplaceActiveImage(imageMap[i])}
										>
											360&deg; View
										</p>
									</li>
								) : (
									''
								)
							})}
						</ProductImageList>
					</ProductImagesContainer>
				</ProductImageHolder>
				<ProductImageContainer>
					{ActiveProductImage != null ? (
						ActiveProductImage.roundview != null ||
						ActiveProductImage.roundview != undefined ? (
							<ProductIframe
								src={`${ActiveProductImage.roundview}`}
								id="iframe360"
								frameborder="0"
								scrolling="no"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
								webkitallowfullscreen="true"
								mozallowfullscreen="true"
								allowfullscreen="true"
								loading="lazy"
							></ProductIframe>
						) : (
							<Magnifier
								src={
									ActiveProductImage != null
										? imageArray.length > 0
											? `${
													ActiveProductImage.fluid.src.split('?')[0]
											  }?fm=png&fl=png8&fit=pad&w=450&h=450`
											: ''
										: ''
								}
								zoomImgSrc={
									ActiveProductImage != null
										? imageArray.length > 0
											? `${
													zoomImg.fluid.src.split('?')[0]
											  }?fm=png&fl=png8&fit=pad&w=800&h=800`
											: ''
										: ''
								}
								// mgShowOverflow={false}
								mgWidth={200}
								mgHeight={200}
								zoomFactor={width >= 768 ? 0.8 : 1.1}
								alt={
									ActiveProductImage != null
										? imageArray.length > 0
											? ActiveProductImage.description
											: ''
										: ''
								}
							/>
						)
					) : (
						<Spinner />
					)}
				</ProductImageContainer>
			</ProductContainer>

			<InfoContainer>
				<BreadCrumbsContainer>
					<Crumbs to={crumbLink}>
						{brand}
					</Crumbs>
					{seriesPageDetails != null ? (
						<>
							{brand != series ? (
								<>
									<ChevronRight width="18px" height="18px" />
									<SeriesCrumbs
										to={`${checkedLocale}/${seriesPageDetails.slug}`}
									>
										{series}
									</SeriesCrumbs>
								</>
							) : (
								''
							)}
						</>
					) : (
						''
					)}
				</BreadCrumbsContainer>
				<ProductTitle>{`${title}`}</ProductTitle>
				<SKU>{sku}</SKU>
				{distinction != null ? (
					series === 'X Line' ? (
						<p tw="text-xs">{distinction}</p>
					) : (
						distinction
					)
				) : (
					''
				)}
				<hr />
				{
					<>
						{series != 'Wave' ? (
							locale === 'en-AU' ? (
								slug !== 'poolside-connect' ? (
									<Price css={tw`mb-2`}>
										{(() => {
											const pricingInfo = getPricingInfo(locale, brand, model)
											return pricingInfo ? (
												<>
													RRP <del>{pricingInfo.originalPrice}</del> On Sale{' '}
												</>
											) : null
										})()}
										{price && price.toLocaleString(locale, {
											style: 'currency',
											currency: currency,
										})}
									</Price>
								) : (
									''
								)
							) : (
								''
							)
						) : (
							''
						)}
					</>
				}
				{
					<>
						{instock === false ? (
							<Stock>
								{comingSoon ? (
									<span>New - Coming Soon</span>
								) : (
									<span className="nostock">Out of Stock</span>
								)}{' '}
								{instock === false ? (
									linkto != undefined || linkto != null ? (
										<>
											– upgrade now to{' '}
											<span
												role="link"
												tabIndex="0"
												className="linkto"
												onClick={() => {
													navigate(`${checkedLocale}/product/${linkto.slug}`)
												}}
												onKeyDown={() => {
													navigate(`${checkedLocale}/product/${linkto.slug}`)
												}}
											>
												{linkto.model}
											</span>
										</>
									) : (
										''
									)
								) : (
									''
								)}
							</Stock>
						) : (
							''
						)}
					</>
				}
				<CtaContainer>
					<>
						{active === null || active === true ? (
							<>
								{series != 'Wave' ? (
									<input
										type="number"
										min={1}
										value={value.quantity < 1 ? '' : value.quantity}
										placeholder="0"
										onChange={e => changeValueHandler(e)}
										onKeyDown={e => changeValueHandler(e)}
									/>
								) : (
									''
								)}
								{series != 'Wave' ? (
									<ControlsContainer>
										<IncrementBtn onClick={() => incrementHandler()}>
											<ChevronUp width="20px" height="20px" />
										</IncrementBtn>
										<DecrementBtn
											disabled={value.quantity <= 1}
											onClick={() => decrementHandler()}
										>
											<ChevronDown width="20px" height="20px" />
										</DecrementBtn>
									</ControlsContainer>
								) : (
									''
								)}
								{series != 'Wave' ? (
									locale === 'en-ZA' ? (
										isZaEnquireProduct ? (
											<Button
												onClick={() => {
													window.location.href = 'https://www.maytronics.com.au/support/contact/'
												}}
											>
												Enquire Now
											</Button>
										) : (
											<Button
												onClick={() => {
													window.location.href = getZaBuyLink(slug)
												}}
											>
												Buy Now
											</Button>
										)
									) : (
									hasUpsell(model) ? (
										<Button
											onClick={() => setPromoModel(model)}
											onKeyDown={() => setPromoModel(model)}
										>
											Add to cart
										</Button>
									) : (
										<Button
											onClick={() => {
												addToCart(value)
												onAddToCart(value, 'Category List')
												openCart()
											}}
											onKeyDown={() => {
												addToCart(value)
												onAddToCart(value, 'Category List')
												openCart()
											}}
											disabled={value.quantity < 1}
										>
											Add to cart
										</Button>
										)
									)
								) : (
									''
								)}
							</>
						) : (
							''
						)}
					</>
				</CtaContainer>

				{categories === null ? (
					<CtaContainer>
						{!isZaEnquireProduct && (
							<BookQuote
								css={tw`ml-0`}
								className={
									active === null || active === true
										? series === 'Wave'
											? ''
											: 'alt'
										: ''
								}
								onClick={() => {}}
								onKeyDown={() => {}}
								to={
									active === null || active === true
										? brand === 'Dolphin' || brand === 'Niya'
											? series === 'Wave'
												? `${checkedLocale}/support/contact/?subject=commercial+trial+${encodeURIComponent(
														model.toLowerCase()
												  )}#contact-form`
												: `${checkedLocale}/book-a-demo`
											: `${checkedLocale}/support/contact/?subject=${encodeURIComponent(
													title.toLowerCase()
											  )}#contact-form`
										: series != 'Wave'
										? `${checkedLocale}/support/contact/?subject=${encodeURIComponent(
												title.toLowerCase()
										  )}#contact-form`
										: `${checkedLocale}/support/contact/?subject=commercial+trial+${encodeURIComponent(
												model.toLowerCase()
										  )}#contact-form`
								}
							>
								{active === null || active === true
									? brand === 'Dolphin' || brand === 'Niya'
										? series === 'Wave'
											? 'Request a Trial'
											: 'Book a Demo'
										: 'Get a Quote'
									: series === 'Wave'
									? locale === 'en-AU'
										? 'Request a Trial'
										: 'Enquire now'
									: 'Enquire Now'}
							</BookQuote>
						)}
						{!isZaEnquireProduct && (
							<CompareBtn
								href={
									comparison
										? `${checkedLocale}/product-comparison#${
												brandPage.slug === 'dolphin' ? tagCheck : brandPage.slug
										  }`
										: '#'
								}
								className="alt"
								onClick={e => {
									comparison
										? checkLength(
												brandPage.slug === 'dolphin' ? tagCheck : brandPage.slug,
												e,
												brandPage.slug,
												tagCheck,
												title
										  )
										: ''
								}}
							>
								Compare
							</CompareBtn>
						)}
					</CtaContainer>
				) : !array.includes(categories.slug) ? (
					<CtaContainer>
						{!isZaEnquireProduct && (
							<BookQuote
								css={tw`ml-0`}
								className={
									active === null || active === true
										? series === 'Wave'
											? ''
											: 'alt'
										: ''
								}
								onClick={() => {}}
								onKeyDown={() => {}}
								to={
									active === null || active === true
										? brand === 'Dolphin' || brand === 'Niya'
											? series === 'Wave'
												? `${checkedLocale}/support/contact/?subject=commercial+trial+${encodeURIComponent(
														model.toLowerCase()
												  )}#contact-form`
												: `${checkedLocale}/book-a-demo`
											: `${checkedLocale}/support/contact/?subject=${encodeURIComponent(
													title.toLowerCase()
											  )}#contact-form`
										: series != 'Wave'
										? locale === 'en-AU' || series === 'E Line' || isZaEnquireProduct
											? `${checkedLocale}/support/contact/?subject=${encodeURIComponent(
													title.toLowerCase()
											  )}#contact-form`
											: `https://mydolphin.co.${getCountry}`
										: `${checkedLocale}/support/contact/?subject=commercial+trial+${encodeURIComponent(
												model.toLowerCase()
										  )}#contact-form`
								}
							>
								{active === null || active === true
									? brand === 'Dolphin' || brand === 'Niya'
										? series === 'Wave'
											? 'Request a Trial'
											: 'Book a Demo'
										: 'Get a Quote'
									: series === 'Wave'
									? locale === 'en-AU'
										? 'Request a Trial'
										: 'Enquire now'
									: locale === 'en-AU' || series === 'E Line' || isZaEnquireProduct
									? 'Enquire Now'
									: 'Buy at MyDolphin'}
							</BookQuote>
						)}
						{!isZaEnquireProduct && (
							<CompareBtn
								href={
									comparison
										? `${checkedLocale}/product-comparison#${
												brandPage && brandPage.slug === 'dolphin' ? tagCheck : brandPage ? brandPage.slug : 'niya'
										  }`
										: '#'
								}
								className="alt"
								onClick={e => {
									comparison
										? checkLength(
												brandPage && brandPage.slug === 'dolphin'
													? tagCheck
													: brandPage ? brandPage.slug : 'niya',
												e,
												brandPage ? brandPage.slug : 'niya',
												tagCheck,
												title
										  )
										: ''
								}}
							>
								Compare
							</CompareBtn>
						)}
					</CtaContainer>
				) : (
					''
				)}
				{comingSoon &&
				instock === false &&
				brandPage &&
				brandPage.slug !== 'dolphin' ? (
					<CtaContainer>
						<BookQuote
							css={tw`ml-0`}
							className={
								active === null || active === true
									? series === 'Wave'
										? ''
										: 'alt'
									: ''
							}
							onClick={() => {}}
							onKeyDown={() => {}}
							to={`${checkedLocale}/support/contact/?subject=ecoclear-pool-equipment#contact-form`}
						>
							Enquire now
						</BookQuote>
					</CtaContainer>
				) : (
					''
				)}

				<FssContainer>
					<TabsContainer>
						{activeTab.map((item, i) => {
							return (
								<Tab
									key={i}
									onClick={() => {
										activeTabHandler(i)
									}}
									className={item.active ? 'active' : ''}
								>
									{item.name}
								</Tab>
							)
						})}
					</TabsContainer>

					<TabDetailsContainer>
						{activeDetail === 0 ? (
							features ? (
								<Accordion collapsible multiple>
									{features.map((item, i) => {
										return (
											<AccordionComponent
												{...{ checkedLocale }}
												item={item}
												key={i}
											/>
										)
									})}
								</Accordion>
							) : brand === 'Eco Clear' ? (
								<p>Nothing under the features</p>
							) : (
								<p>Features not yet available</p>
							)
						) : activeDetail === 1 ? (
							<SpecificationsContainer>
								<SpecificationsList>
									{specifications ? (
										specifications.map((item, i) => {
											if (item.title) {
												return (
													<SpecificationsListItem key={i}>
														<SpecGroupTitle>{item.title}</SpecGroupTitle>
													</SpecificationsListItem>
												)
											}
											return (
												<SpecificationsListItem key={i}>
													<SpecDetail>
														<Spec>{item.spec}:</Spec>{' '}
														{item.detail
															? item.detail
															: item.details.map(val => {
																	return (
																		<SpecInnerItem key={val}>
																			<CircleSvg
																				width="6"
																				height="6"
																				fill="#000"
																			/>
																			{val}
																		</SpecInnerItem>
																	)
															  })}
													</SpecDetail>
												</SpecificationsListItem>
											)
										})
									) : brand === 'Eco Clear' ? (
										<p>Nothing under the specifications</p>
									) : (
										<p>Specification not yet available</p>
									)}
								</SpecificationsList>
							</SpecificationsContainer>
						) : (
							<SupportContainer>
								<Manual href={manualFile} target="_blank">
									Manual
								</Manual>
								<Brochure href={brochureFile} target="_blank">
									Brochure
								</Brochure>
								<Parts
									href={`${checkedLocale}/support/repairs-and-parts/`}
									target="_blank"
								>
									Parts
								</Parts>
								{msdsFile && (
									<MSDS href={msdsFile} target="_blank">
										MSDS
									</MSDS>
								)}

								{warrantyFile && (
									<WarrantyDownload href={warrantyFile} target="_blank">
										Warranty
									</WarrantyDownload>
								)}
									<SafetyInstructions href={safetyInstructionsFile} target="_blank">
										Safety Instruction
									</SafetyInstructions>
							</SupportContainer>
						)}
					</TabDetailsContainer>
				</FssContainer>
			</InfoContainer>

			<UpsellDialog
				model={promoModel}
				open={promoModel !== null}
				onClose={() => setPromoModel(null)}
				onContinue={() => {
					addToCart(value)
					onAddToCart(value, 'Category List')
					openCart()
					setPromoModel(null)
				}}
			/>
		</ProductInfoContainer>
	)
}

export default ProductInfo

ProductInfo.propTypes = {
	imageArray: PropTypes.array,
	brand: PropTypes.string,
	series: PropTypes.string,
	model: PropTypes.string,
	price: PropTypes.string,
	sku: PropTypes.string,
	categories: PropTypes.array,
	shippingClass: PropTypes.string,
	slug: PropTypes.string,
	val: PropTypes.string,
	feature: PropTypes.array,
	specifications: PropTypes.object,
	brochure: PropTypes.string,
	manual: PropTypes.string,
	msds: PropTypes.string,
	warrantyDownload: PropTypes.string,
	distinction: PropTypes.string,
	tags: PropTypes.array,
	brandPage: PropTypes.object,
	title: PropTypes.string,
	comparisonitem: PropTypes.bool,
	seriesPageDetails: PropTypes.object,
	degreeView: PropTypes.string,
	zoom: PropTypes.object,
	active: PropTypes.bool,
	instock: PropTypes.bool,
	comingSoon: PropTypes.bool,
	linkto: PropTypes.string,
	checkedLocale: PropTypes.string,
	currency: PropTypes.string,
	locale: PropTypes.string,
}
